// Line-numbered textarea for document editing
import React, { forwardRef, useEffect, useState, useRef } from 'react';

export const LineNumberedTextarea = forwardRef(({ 
  value, 
  onChange, 
  onSelect,
  className = '',
  style = {},
  ...props 
}, ref) => {
  const [lineCount, setLineCount] = useState(1);
  const lineNumbersRef = useRef(null);
  const textareaRef = ref || useRef(null);

  useEffect(() => {
    // Calculate line count
    const lines = value ? value.split('\n').length : 1;
    setLineCount(lines);
  }, [value]);

  const handleScroll = (e) => {
    // Sync scroll position of line numbers with textarea
    if (lineNumbersRef.current) {
      lineNumbersRef.current.scrollTop = e.target.scrollTop;
    }
  };

  const lineNumbers = Array.from({ length: lineCount }, (_, i) => i + 1);

  return (
    <div className="flex flex-1 relative">
      {/* Line Numbers */}
      <div 
        ref={lineNumbersRef}
        className="overflow-hidden border-r border-gray-300 bg-gray-50 text-gray-500 text-right select-none"
        style={{
          width: '50px',
          paddingTop: '24px',
          paddingRight: '8px',
          lineHeight: '1.75rem',
          fontSize: '0.875rem',
          fontFamily: 'monospace',
          maxHeight: style.minHeight || '600px',
          overflowY: 'hidden'
        }}
      >
        {lineNumbers.map(num => (
          <div key={num} style={{ height: '1.75rem' }}>
            {num}
          </div>
        ))}
      </div>

      {/* Textarea */}
      <textarea
        ref={textareaRef}
        value={value}
        onChange={onChange}
        onSelect={onSelect}
        onScroll={handleScroll}
        className={className}
        style={{
          ...style,
          flex: 1,
          paddingLeft: '16px',
          lineHeight: '1.75rem'
        }}
        {...props}
      />
    </div>
  );
});

LineNumberedTextarea.displayName = 'LineNumberedTextarea';
